import { socket } from '../socket'
import { getTokenPayload } from '../../utils/getTokenPayload'

export const connectNotificationSocket = () => {
  const payload = getTokenPayload()
  if (payload) {
    const { public_id, id_cliente } = payload
    socket.emit('connectNotification', {userId: public_id, clientId: id_cliente}) 
  }
}